// extracted by mini-css-extract-plugin
export var audioPlayer = "_r2-0";